//region block: pre-declaration
//endregion
function get_useEngineDispatcher() {
  return useEngineDispatcher;
}
var useEngineDispatcher;
//region block: init
useEngineDispatcher = true;
//endregion
//region block: exports
export {
  get_useEngineDispatcher as get_useEngineDispatcher3ja9ea3m8f657,
};
//endregion

//# sourceMappingURL=DispatcherSwitching.nonJvm.mjs.map
